import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader, SectionHeading } from '../../components/ui/Primitives';

export default function AdminAdvanced() {
  const tools = [
    { title: 'Messages', description: 'Direct platform communication.', to: '/admin/advanced/messages' },
    { title: 'Admin access', description: 'Create a dedicated administrator account.', to: '/admin/advanced/access' },
    { title: 'Systems', description: 'Review system links and operational flow.', to: '/admin/advanced/systems' }
  ];
  return <div><PageHeader eyebrow="Administration" title="Advanced" description="Less frequently used platform tools." /><SectionHeading title="Advanced tools" /><div className="settings-list">{tools.map(tool => <Link className="settings-row" key={tool.title} to={tool.to}><span><strong>{tool.title}</strong><span>{tool.description}</span></span><b aria-hidden="true">→</b></Link>)}</div></div>;
}
